import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_2 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "text-center" }

import { ref, onMounted, watch } from "vue";
import AccountOverviewService from "@/projects/tenant/views/accountOverview/services/AccountOverviewServices";
import { PaymentStatusTypes } from "@/core/types/PaymentTypes";
import { TransactionStateType } from "@/core/types/StateInfos";

export default /*#__PURE__*/_defineComponent({
  __name: 'acccountDeposit',
  props: {
  account: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const isLoading = ref(false);
const data = ref<any>([]);



const criteria = ref({
  page: 1,
  size: 10,
  accountId: props.account.id,
} as any);

const fetchData = async (_page: number) => {
  if (props.account.accountNumber === undefined) return;
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await AccountOverviewService.queryDeposits(criteria.value);
    criteria.value = res.criteria;
    data.value = res.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

watch(
  () => props.account,
  (newAccount, oldAccount) => {
    if (newAccount && newAccount.id !== oldAccount?.id) {
      resetCriteria();
      fetchData(1);
    }
  },
  { deep: true }
);

const resetCriteria = () => {
  criteria.value = {
    size: 10,
    accountId: props.account.id,
    accountNumber: props.account.accountNumber,
    serviceId: props.account.serviceId,
  };
};

onMounted(() => {
  fetchData(1);
});

const pageChange = (page: number) => {
  criteria.value.page = page;
  fetchData(page);
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_2, [
          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.deposit") + " " + _ctx.$t("fields.status")), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentStatus")), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentId")), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t("title.paymentMethod")), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.currency")), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.amount")), 1),
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t("fields.createdOn")), 1)
        ])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
            _createVNode(_component_LoadingRing)
          ]))
        : (!isLoading.value && data.value.length === 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
              _createVNode(_component_NoDataBox)
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: _normalizeClass({
          'text-gray-400':
            item.stateId === _unref(TransactionStateType).DepositCanceled,
        })
                }, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.transactionState.${item.stateId}`).replace(
              /^Deposit\s+/,
              ""
            )), 1),
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", {
              'badge-primary':
                item.payment.status === _unref(PaymentStatusTypes).Pending,
              'badge-success':
                item.payment.status === _unref(PaymentStatusTypes).Completed,
              'badge-danger':
                item.payment.status === _unref(PaymentStatusTypes).Cancelled,
              'badge-warning':
                item.payment.status === _unref(PaymentStatusTypes).Executing,
            }])
                    }, _toDisplayString(_ctx.$t(`type.paymentStatus.${item.payment.status}`)), 3)
                  ]),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(item.payment.id), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(item.payment.paymentServiceName), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t(`type.currency.${item.currencyId}`)), 1),
                  _createElementVNode("td", _hoisted_11, [
                    _createVNode(_component_BalanceShow, {
                      "currency-id": item.currencyId,
                      balance: item.amount
                    }, null, 8, ["currency-id", "balance"])
                  ]),
                  _createElementVNode("td", _hoisted_12, [
                    _createVNode(_component_TimeShow, {
                      "date-iso-string": item.createdOn
                    }, null, 8, ["date-iso-string"])
                  ])
                ], 2))
              }), 128))
            ]))
    ]),
    _createVNode(_component_TableFooter, {
      onPageChange: pageChange,
      criteria: criteria.value
    }, null, 8, ["criteria"])
  ], 64))
}
}

})